import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const ceresChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    662709600 as Seconds,
    new Float64Array([
      -461150916.80529159, -190374323.5546571, 37367711.744744018, 4912897.1848262399, -510757.92014330102, -56682.880992158753, 10794.298073104956, 222.27795731754352,
      -3131.5021114849174, 191.09726020951445, 1855.0883353755498, -126.71108675127228,
    ]),
    new Float64Array([
      382312552.89407235, -201655409.02836263, -30500556.171035696, 4746891.5491267322, 523081.56331032712, -46030.098028488952, -18833.665059942006, 782.51705896655722,
      6261.01141876777, -339.10455900231995, -3641.8200566470623, 295.90955496827763,
    ]),
    new Float64Array([
      273757574.09465003, -55938936.230777256, -21963622.815116346, 1229234.8104508349, 350280.6292857448, -10087.814742768804, -11078.012220878401, 323.40710483094057,
      3590.9432108342648, -198.85782022376856, -2095.5688159743945, 165.38855594893298,
    ])
  ),
  new ChebyshevCoefficients(
    662709600 as Seconds,
    694267200 as Seconds,
    new Float64Array([
      -496579605.19904679, 170209131.16717634, 35025082.90770787, -4537768.2087627826, -231260.65592478315, 51844.473077386618, -10881.639076530933, 13.071218093236288,
      4528.8761334041756, -303.4423568546772, -2667.878649522861, 228.61596419612567,
    ]),
    new Float64Array([
      -485368352.39427346, -177500851.43213353, 32997786.813963253, 3105419.5910832197, -511864.71620923601, -4706.6661171863479, 9995.4391425741214, -387.34634402940668,
      -2624.2750648379324, 152.15971972147622, 1503.3138435952364, -153.33702151775361,
    ]),
    new Float64Array([
      -126846272.73662354, -118155647.72867179, 8365189.6795627093, 2385606.6442910442, -193290.44653984084, -12789.004385344932, 6888.1769664888579, -183.63354049275318,
      -2145.0232724539937, 132.68847285633285, 1243.7118679563205, -118.00057038366795,
    ])
  ),
  new ChebyshevCoefficients(
    694267200 as Seconds,
    725824800 as Seconds,
    new Float64Array([
      381793205.44068599, 222739369.28062358, -19621097.733816288, -3485270.3304527937, 197815.92132965475, 1378.2864912733435, 1840.8130376222232, 79.162589544802898,
      -1112.4924925044179, 43.492876856774089, 653.23156230151653, -35.229416684309641,
    ]),
    new Float64Array([
      -599241766.12394261, 118658161.09055465, 31458358.473519474, -2410247.7500730953, -165792.4740058899, 12943.705377491315, -1982.0430711070696, 22.625415184100468,
      476.14969326853753, -18.740825003385545, -275.65898697177568, 14.866558694839478,
    ]),
    new Float64Array([
      -359542077.94317263, 10345100.82181255, 18790206.365706053, -422110.22047773795, -118194.4698735257, 5806.2718147814276, -1327.8871867299081, -5.111457270383835,
      459.22462819814683, -18.015845331549645, -267.79577194352942, 14.442487793167432,
    ])
  ),
  new ChebyshevCoefficients(
    725824800 as Seconds,
    757382400 as Seconds,
    new Float64Array([
      775032181.5738039, -43789173.418371223, -40683297.428862333, 163983.24338212807, 281180.83592993615, 11646.55011506478, 3155.3618403851988, -185.23522740999857,
      -1260.3449574172496, 59.458542245626447, 737.11015329360964, -48.48122452497482,
    ]),
    new Float64Array([
      148620075.66981947, 222071605.38881794, -8148153.026478502, -3873488.3402430397, -23271.713750315706, 10037.491653835774, 295.13704215983552, 109.38777494927247,
      364.04682375291981, -17.748529516657193, -216.92899813552697, 14.38305557469527,
    ]),
    new Float64Array([
      -88194438.652568355, 113325484.17623523, 4467936.149755206, -1854386.4489869415, -68228.818972867724, 2342.6274467736484, -519.2649158090353, 89.559687776366872,
      434.13355652987957, -20.770417857170106, -255.76953628460566, 16.857435277104379,
    ])
  ),
  new ChebyshevCoefficients(
    757382400 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      91282145.867658705, -268783196.95583975, -5437708.5534394579, 5803455.9649604084, 290569.36581264733, -42156.179055833818, -16331.37812774976, 568.95869234601651,
      5461.1351680676144, -307.06172822117804, -3193.5610792140164, 247.38975768089293,
    ]),
    new Float64Array([
      637199451.54248369, -9070006.8567701895, -44608683.420861103, -812720.62641421554, 504328.92140428623, 29701.828007723889, -891.91560268600779, -408.35228656729061,
      -775.17805767655375, 25.651217317581175, 428.99864026705421, -53.04152886470159,
    ]),
    new Float64Array([
      280946462.16171646, 50558790.344306856, -19862145.358448129, -1565942.3808494504, 177877.23165510991, 22565.054425410428, 2902.1795154596366, -307.76352753837904,
      -1474.4127893447876, 74.476852418482309, 850.78335829923549, -75.211752719680462,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    820497600 as Seconds,
    new Float64Array([
      -642605212.47510958, -49007596.863379836, 51323442.864307575, 800601.70590999618, -784827.84228631458, 1700.786969996492, 22485.438150893649, -713.96140753229463,
      -7155.2532211134831, 444.26208132505417, 4153.4125967174768, -392.62034636239213,
    ]),
    new Float64Array([
      37719792.907397225, -255404200.2885665, -3395975.0343210427, 6260553.821516702, -37482.548438511294, -64982.810804267727, 6896.2260759433111, 265.9240158011516,
      -2549.2565326521794, 194.70908880035083, 1537.9493834535281, -106.82573089202245,
    ]),
    new Float64Array([
      148806388.1596944, -110075677.6843472, -12065074.343187204, 2779976.0921567916, 142504.32713450788, -30896.969681983192, -1352.3091880937418, 271.09267091850438,
      264.66731303930283, 0.75360716978708897, -126.19545275866984, 30.118145965536435,
    ])
  ),
  new ChebyshevCoefficients(
    820497600 as Seconds,
    852055200 as Seconds,
    new Float64Array([
      -182414109.71561107, 244752649.76439294, 11904105.377971986, -5057793.2902519619, 82349.961884653574, 29885.327423737446, -8781.3208144148193, 99.662684071063993,
      2724.1980030695595, -107.42746771772703, -1591.633350855112, 85.838342662652337,
    ]),
    new Float64Array([
      -668510373.90453303, -60506823.232435994, 40576355.502345212, 198198.95887983937, -381888.18030501902, 21070.525463012855, -4379.2171459823849, -124.59476525386174,
      2420.958333823085, -94.833327516913414, -1421.0539034138123, 76.638826211293534,
    ]),
    new Float64Array([
      -277061985.03656971, -78358551.366548643, 16651872.870222311, 1126206.2209942373, -196026.22634484916, 3783.8868462070823, -312.864625214537, -77.780302305519584,
      600.03449358517923, -23.364698921640713, -353.70571647857628, 19.075695051004487,
    ])
  ),
  new ChebyshevCoefficients(
    852055200 as Seconds,
    883612800 as Seconds,
    new Float64Array([
      661182745.43647373, 139422099.44540954, -33036637.470625084, -2149628.6570147732, 215384.19762546718, 1178.9138847261668, 766.96234107712905, 53.90511343081792,
      -195.07797099749246, 5.7918166369199753, 117.16556262274582, -10.606253721316655,
    ]),
    new Float64Array([
      -357166744.43753022, 196792682.09856811, 17896450.148441806, -3231092.5521993935, -96431.052100551125, 5830.6094902157784, -294.84610813458761, 73.143432056903833,
      -64.916201871633533, 5.547180380423864, 35.599919664859769, 0.19678062399228413,
    ]),
    new Float64Array([
      -302567316.76414007, 64171279.298625164, 15160953.522330007, -1082707.2669497728, -89546.027699160579, 2525.2903553018969, -301.37897171477476, 23.356715184450149,
      13.225895195206006, 1.2033719857533773, -9.4278772562742237, 2.3689484099547067,
    ])
  ),
  new ChebyshevCoefficients(
    883612800 as Seconds,
    915170400 as Seconds,
    new Float64Array([
      618217186.30502331, -162760795.52731606, -34958891.583690494, 2214303.2143213409, 355981.25509754021, 10035.679245229561, 3325.8978362639746, -390.66324337124826,
      -2059.6579700350762, 105.60626262426376, 1191.925935248534, -103.82176281213761,
    ]),
    new Float64Array([
      445690979.70218188, 167822066.19279444, -25963149.112289093, -3656472.9544484075, 87287.381422933817, 25077.428946986423, 5941.138172010953, -196.515994975095,
      -1902.9780298686276, 114.90405824333429, 1123.107761415094, -78.691626602783799,
    ]),
    new Float64Array([
      83932645.067074314, 112120284.47493958, -5100776.2772568054, -2172472.8083497835, -31192.447303865352, 9755.0369649077456, 2096.3196123580137, -12.083919700483481,
      -467.62172903617221, 32.122096397479375, 280.88618982483945, -15.475681495666503,
    ])
  ),
  new ChebyshevCoefficients(
    915170400 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      -287740498.22329235, -241009379.43534347, 23054665.230748583, 6119676.7033133749, -165691.85488746315, -68232.406046962744, -7524.0065076609453, 841.21625276356929,
      3317.1499168713885, -162.44505881071092, -1862.0016531263789, 222.28219183087347,
    ]),
    new Float64Array([
      522018626.20110589, -142572961.38542724, -40252426.33351849, 2819831.3503838778, 656602.33970016835, -14749.352971788247, -20018.856736960013, 545.58908243378005,
      6350.335989707708, -416.91075923244159, -3720.3396042486033, 328.1182199517886,
    ]),
    new Float64Array([
      304289452.34404033, -18042092.350067429, -23641301.655835982, 81164.34644614358, 342925.23398024141, 6953.0262089560429, -7912.0302827805281, 86.241919091343874,
      2322.4019760866959, -163.68969258069993, -1377.0835178226232, 109.67885990043482,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    978285600 as Seconds,
    new Float64Array([
      -599996526.74871039, 103937384.18840797, 45247475.759316303, -3292335.5887592612, -498411.0340991338, 49744.407532660167, 572.43698614835739, -399.66341589291892,
      821.18471432129536, -31.064556976159412, -485.36729952692986, 26.176332986354826,
    ]),
    new Float64Array([
      -322130983.06665879, -224547835.59142765, 23350667.366628628, 4770014.3485268913, -480111.36424676079, -32017.383880260091, 18903.669274043539, -225.6479884515206,
      -6215.2679802571729, 244.93865005324284, 3636.8802563965319, -196.14050766875346,
    ]),
    new Float64Array([
      -29488758.297621075, -126858917.55153292, 1779334.8899897272, 2915725.1079270099, -124459.9294612497, -25201.710888346533, 8768.7459746380646, -24.537801644702753,
      -3087.4594592819612, 121.40936269362767, 1807.61445197016, -97.486414546767875,
    ])
  ),
  new ChebyshevCoefficients(
    978285600 as Seconds,
    1009843200 as Seconds,
    new Float64Array([
      197618741.82970572, 247420209.75150725, -10283719.758571753, -4153468.5388716538, 194451.38872177203, 6320.0956468542417, 303.43904765049615, 104.89546473821004,
      -872.70670358041923, 52.08288207054138, 496.77265141407651, -21.692225599288939,
    ]),
    new Float64Array([
      -667546970.67999125, 62440779.62045221, 36657044.686793409, -1809521.4107499679, -218769.90183195868, 19682.998848623036, -4820.8703154424829, 18.383990434805551,
      1760.1315636833508, -78.735841782887775, -1035.8940623521805, 71.838448564211532,
    ]),
    new Float64Array([
      -354463594.74639225, -20977824.831629317, 19348825.384955008, -6196.3749911338091, -142496.38993801078, 7980.2419815182684, -2343.6774637758731, -12.431600926319758,
      1011.2963307922086, -47.922723286847273, -591.71448022127151, 38.410666506489115,
    ])
  ),
  new ChebyshevCoefficients(
    1009843200 as Seconds,
    1041400800 as Seconds,
    new Float64Array([
      787640288.69966793, 22945905.707400274, -39810911.354428351, -693388.4367403388, 242326.72868240674, 7240.4468821545443, 1414.6663393974304, -42.315608032544453,
      -324.76744452317553, 24.65971015294393, 196.98482868075371, -8.4869294762611389,
    ]),
    new Float64Array([
      -29120377.231554516, 227038563.9825795, 1279121.0180400023, -3686748.230894648, -49607.648243113355, 4962.9051322321093, -752.70738147497173, 151.06032333175341,
      555.94125098784764, -28.903367013732591, -322.62700092295808, 27.935083083311717,
    ]),
    new Float64Array([
      -174051315.98617175, 102205499.19875419, 8707642.6538771894, -1594315.346098881, -72675.097296277687, 860.57042747040589, -649.63280573387942, 79.981997124354038,
      330.92329147060713, -18.788011332352955, -193.77588560084502, 15.030531339844067,
    ])
  ),
  new ChebyshevCoefficients(
    1041400800 as Seconds,
    1072958400 as Seconds,
    new Float64Array([
      301707959.31464267, -248631054.69782162, -18711216.977881987, 4659910.7227821769, 389636.11026810604, -16852.547037867706, -9208.8389250338078, 75.59646847248078,
      2318.7633714119593, -186.77933702071508, -1407.1957952002683, 88.233157992362976,
    ]),
    new Float64Array([
      619372070.68011284, 61805926.7430567, -40464888.303657107, -2319774.4394007879, 322969.19562669494, 38369.351396602389, 8209.1414660493538, -678.40331304272013,
      -3754.7038270344337, 212.033485241731, 2150.8083258281149, -226.17031317849953,
    ]),
    new Float64Array([
      230155022.28812647, 79712659.354503274, -15240598.936320972, -2040901.2641817918, 72783.721012054128, 21485.599758622298, 5719.3810586626332, -333.80747932977977,
      -2231.2443165021637, 137.37119699281951, 1294.1945517677814, -123.92882681389649,
    ])
  ),
  new ChebyshevCoefficients(
    1072958400 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      -567668709.98114145, -129754849.8627667, 46551051.677357577, 3263539.261666249, -725346.64088653866, -35539.832894580068, 22203.350980555515, -113.15207740217447,
      -7168.8566841229795, 281.72350036005179, 4195.0217754989862, -226.24162550568579,
    ]),
    new Float64Array([
      231652007.43344072, -237741040.13730335, -18959690.581858829, 5897456.1528757615, 308270.56459706824, -63711.419719994068, -10507.868733644485, 652.5153539041678,
      3475.1855149368444, -138.68529851635296, -2034.0300413946311, 109.69722869396209,
    ]),
    new Float64Array([
      224587189.0477868, -85525523.161296785, -18408805.2606631, 2111568.6871246286, 293027.58735871414, -22738.178213061889, -9485.6802268117663, 330.33171406586962,
      3102.5380047857761, -122.92093807558219, -1815.737688078483, 97.924508656064674,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1136073600 as Seconds,
    new Float64Array([
      -357094266.44336075, 215308741.53703037, 24303648.132470194, -5132592.4749298654, -41719.765062151353, 46106.921433768672, -13973.174695014954, 74.590730384985605,
      5171.0189486642676, -249.49396171371143, -3018.3158324579399, 192.02725202639897,
    ]),
    new Float64Array([
      -592481609.91757476, -125028042.88572931, 38588124.25990963, 1624108.9763728459, -482023.96242895973, 12851.439774731794, 2069.4759290958445, -260.90938381105661,
      399.4999095713099, -36.246900570889316, -209.36025382379691, -3.7791700666149457,
    ]),
    new Float64Array([
      -206390445.64998201, -102727310.53886053, 13224335.829529306, 1810986.8206041039, -218533.26019447049, -3360.3043906953185, 3820.9033765653767, -137.81804974265395,
      -864.92939580945915, 33.74089714214206, 516.0713838373, -40.882284673862159,
    ])
  ),
  new ChebyshevCoefficients(
    1136073600 as Seconds,
    1167631200 as Seconds,
    new Float64Array([
      534685080.57501113, 187518815.46614021, -26920711.267949253, -2815253.4339598948, 206110.25511830102, -774.58606637666617, 1810.3972103975714, 54.461560890823598,
      -831.69089403226974, 46.966113056739168, 487.33900189325215, -37.142651104927062,
    ]),
    new Float64Array([
      -496569896.00239199, 161291218.22833154, 25317544.466203887, -2866731.8982584896, -122539.1845064044, 8626.6138339817517, -563.55286358396211, 40.160799088080722,
      -117.56416748563448, 5.4127397775650028, 70.270660048723215, -6.6726994415124254,
    ]),
    new Float64Array([
      -342781999.77308166, 37794958.049970277, 17407240.855619181, -777153.95225812588, -99588.517399203774, 4224.4663389354946, -657.31258630553884, 8.5331862896680839,
      123.39807077348232, -7.5190678874651589, -71.618054093917209, 4.8702982147534684,
    ])
  ),
  new ChebyshevCoefficients(
    1167631200 as Seconds,
    1199188800 as Seconds,
    new Float64Array([
      723975127.5342294, -103146842.26613818, -39040765.556897089, 1063035.1527232747, 311629.82019157807, 13491.804229811827, 4385.1168721874556, -360.10425946911175,
      -2044.1643880248068, 128.51625108917554, 1189.8206603328388, -111.50544535517692,
    ]),
    new Float64Array([
      301446046.0427416, 202471143.89180195, -16757391.989661252, -3846083.6256843619, 15661.083902313809, 15803.150979929416, 2380.2484669109185, 37.913486749927202,
      -332.44916835278275, 47.816685734937586, 230.65766737783949, 6.6627185612916948,
    ]),
    new Float64Array([
      -5413268.5909080906, 116378454.93097334, 55366.006185243525, -2028183.7075798761, -55972.58004889985, 4693.3432895059386, 205.91125444471837, 92.112519107758999,
      268.9388019959132, -4.1777851894497875, -138.96782866468033, 26.395187619825204,
    ])
  ),
  new ChebyshevCoefficients(
    1199188800 as Seconds,
    1230746400 as Seconds,
    new Float64Array([
      -94364106.354234904, -266597628.01029685, 7937664.5748656457, 6332302.6934186779, 123270.97987053393, -60412.197009570402, -17391.352087368567, 711.1377994130055,
      6376.7463994592426, -252.76550811429817, -3734.5155174036822, 201.40607322653133,
    ]),
    new Float64Array([
      605148824.76869535, -74976251.926472634, -44705346.587954991, 823971.97101428115, 626376.67595989897, 13493.821076621613, -11225.113961835703, -84.158567212025318,
      2948.3450330177943, -114.93575786153475, -1721.5341448446115, 92.844019552071885,
    ]),
    new Float64Array([
      304273134.8374663, 18962523.773046296, -22676733.221620418, -901279.62206026062, 270124.21113949071, 18658.337837084135, -1773.4004754672449, -183.88053337136904,
      101.26936694582304, -3.1023956090211868, -56.889492035905519, 3.0681058739622435,
    ])
  ),
  new ChebyshevCoefficients(
    1230746400 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      -647813827.16209924, 27164474.084459972, 50964223.001835041, -1376617.1713549932, -711401.6721806447, 30685.104525697232, 14823.848708258072, -606.65728544990225,
      -4236.1031511942547, 187.9567673822244, 2498.2397275646526, -176.28545591036479,
    ]),
    new Float64Array([
      -142129463.12895316, -251049523.94987765, 10510085.495524026, 5908756.802995272, -306888.2977224082, -54914.066554758945, 17662.782080137731, -31.927715547879536,
      -6200.1871146162348, 307.37609617014726, 3604.8189649522305, -221.03079613645872,
    ]),
    new Float64Array([
      64928793.964454643, -123797731.36668885, -5426304.7821615702, 3063825.3194709728, 386.21148267388344, -32116.885219255088, 5281.5750119954346, 108.98589315215746,
      -2049.7267302304508, 106.09768883685271, 1184.5236600925525, -67.930337127049768,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1293861600 as Seconds,
    new Float64Array([
      2757498.5197258689, 254592816.14692262, 528295.90504818561, -4721701.2172607025, 159945.9795754244, 16323.994286819299, -3782.854269617796, 137.66049643854299,
      611.65896188418071, -31.242781256635983, -347.99431770245235, 30.266576574246088,
    ]),
    new Float64Array([
      -691386356.26314247, 818407.30432258849, 39861345.654125959, -927797.93552558415, -293157.79196129041, 23225.386833393575, -6449.0440296332044, 12.144415420293807,
      2773.972462028265, -156.14093714157741, -1625.2026325762272, 125.21648826201756,
    ]),
    new Float64Array([
      -326285666.40120244, -51452746.659029879, 18670788.5519314, 524489.0784903476, -170552.40132151145, 7617.1498729849854, -2286.8618163987994, -21.717279547452925,
      1189.9641726319987, -67.608501158157978, -699.25143844087916, 53.194502306481205,
    ])
  ),
  new ChebyshevCoefficients(
    1293861600 as Seconds,
    1325419200 as Seconds,
    new Float64Array([
      744878876.38163924, 84938415.616857633, -37241660.664454579, -1472192.6304862679, 223017.63764431377, 4074.4138431519268, 855.90468069513634, 27.650384015838306,
      -82.719535791873938, 16.604869924982388, 62.600855483611426, 6.2097379535436632,
    ]),
    new Float64Array([
      -203206560.57550883, 218126341.77459601, 10108291.285344524, -3485342.8671948891, -75425.088318304217, 4039.2878964483739, -490.48494566480321, 118.96101661920547,
      226.45810225804647, -15.490936563412347, -133.0083658874035, 11.459889523188274,
    ]),
    new Float64Array([
      -247387676.11424896, 85478852.600435063, 12348286.307650669, -1341897.0092441768, -80886.75238064627, 1068.8224806110063, -419.83946934541063, 50.866418388485911,
      129.19768899778524, -11.047989465792973, -78.729442611336708, 4.4309264093637468,
    ])
  ),
  new ChebyshevCoefficients(
    1325419200 as Seconds,
    1356976800 as Seconds,
    new Float64Array([
      477111385.8559137, -211803058.97053725, -28423443.610406503, 3436668.7859104373, 395243.72743878164, -340.6010627945264, -2016.246221858263, -216.13667655587196,
      -309.0564359585444, 13.503306547800699, 186.35575716892879, -10.050347729523976,
    ]),
    new Float64Array([
      550494097.5817771, 121617174.43554509, -33921367.375329889, -3203187.4473010306, 190060.79648857613, 34223.780683796605, 8727.1126251866426, -384.69681137849886,
      -3397.7683914174636, 134.57537079254786, 1989.4782600094875, -107.29450771212578,
    ]),
    new Float64Array([
      162318162.35716307, 100461670.83503959, -10192791.858119607, -2210324.6823682021, 8852.2995460253205, 16210.864182511717, 4536.6979624550786, -137.60647328247626,
      -1542.8998497103651, 60.851976713910695, 902.30667680179079, -48.66228137500584,
    ])
  ),
  new ChebyshevCoefficients(
    1356976800 as Seconds,
    1388534400 as Seconds,
    new Float64Array([
      -448199502.01042718, -195565820.9893769, 36144625.344801836, 5041577.0249801464, -474930.90612000995, -58107.754694605101, 8471.3739553983633, 321.01558888485499,
      -2341.9475452932993, 124.66081941747106, 1342.2782307100404, -72.569602845407402,
    ]),
    new Float64Array([
      397330704.61653435, -196802486.19065708, -31493037.25826811, 4570157.3658584133, 538433.57838835719, -42724.621401466924, -19103.720839635531, 666.83677008549375,
      6304.6868210991224, -297.34718074798582, -3692.4074761450288, 242.97500670552253,
    ]),
    new Float64Array([
      278613169.44690371, -52926950.119887985, -22210734.987116765, 1127107.807949553, 350741.32507518231, -8311.0118233690664, -10746.516881565252, 249.48911787867544,
      3454.8365651528038, -165.83395783205827, -2017.3972036014, 129.54352625608445,
    ])
  ),
  new ChebyshevCoefficients(
    1388534400 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      -508512186.49068922, 165014186.86600417, 36133940.209425293, -4449913.7235995708, -259594.9068231225, 52193.424004608394, -9740.0550634423889, -75.414986699819565,
      4170.061250338952, -238.78283241589864, -2451.0565710544588, 184.49412445425986,
    ]),
    new Float64Array([
      -470848773.03019601, -182352940.74201244, 32268768.586283702, 3279896.0983794159, -513273.01107672293, -7587.9950359955428, 11121.47596059665, -353.32773456436894,
      -3052.4708737184606, 164.34180732431511, 1770.4472332427899, -144.71326093773047,
    ]),
    new Float64Array([
      -118355519.75090072, -119579696.53577811, 7849986.3768077372, 2452916.2802732936, -188959.91281577223, -14215.295055876175, 7201.9748670135932, -150.34154063090682,
      -2278.1070553143818, 125.56537551557024, 1327.8984080354373, -105.30340194180607,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1451649600 as Seconds,
    new Float64Array([
      366353078.05286688, 225777809.95506561, -18929142.183658816, -3558060.4503171528, 200605.97630876178, 1875.2373887009919, 1719.4967853372295, 45.042812489469846,
      -1105.8264558623234, 73.125746738165617, 651.6229511857033, -56.729806987444562,
    ]),
    new Float64Array([
      -605455559.52355039, 114215754.78420927, 32010371.927376539, -2378764.7358017862, -170741.23023170829, 13818.196277451514, -2289.5561605294547, 40.251127364238101,
      611.19120575586953, -39.861994290351866, -355.17499578595164, 31.443471721808116,
    ]),
    new Float64Array([
      -360033528.84020555, 7849498.6099870512, 18946012.622746449, -396536.16061012447, -121197.38332409661, 6131.1941182682913, -1459.4860169867675, 10.924270649751028,
      525.56988612810767, -34.405965771277742, -307.20352474153043, 27.083424308896063,
    ])
  ),
  new ChebyshevCoefficients(
    1451649600 as Seconds,
    1483207200 as Seconds,
    new Float64Array([
      778256214.25969362, -38053335.338681556, -40676511.225096717, 102927.85693090757, 277340.43137175241, 10868.132152118285, 2877.934267737468, -153.88866608937582,
      -1123.0745506564776, 44.407399292786913, 656.03478951056798, -35.380597474177677,
    ]),
    new Float64Array([
      134990077.75938722, 222977907.6181508, -7378030.9974060375, -3853998.0255439607, -23150.189296741286, 9447.9340288738404, 117.3712716470162, 109.51037357946237,
      404.29054526388643, -16.615364945928256, -239.94975337386131, 12.940724311272303,
    ]),
    new Float64Array([
      -94877415.924879417, 112871486.62338595, 4808161.2879905021, -1837947.0664257209, -67313.479530534154, 2241.4684106936056, -553.62782765527561, 83.446950165430707,
      428.72389926612374, -17.248522864778835, -252.24337580204011, 13.603731617331505,
    ])
  ),
  new ChebyshevCoefficients(
    1483207200 as Seconds,
    1514764800 as Seconds,
    new Float64Array([
      110562230.54583734, -267579639.34354597, -6708389.1282632491, 5688565.5946533922, 301007.34243118763, -39025.244821830587, -15531.783041809002, 443.59826664924623,
      5113.7705826739466, -246.24637017846106, -2984.1574278553326, 190.83818804025651,
    ]),
    new Float64Array([
      639098575.04348385, -2517256.0501097362, -44253534.339261197, -962399.18513729179, 482714.63975387911, 30758.310239187875, 478.05527124206225, -417.60700368285177,
      -1208.1744718352954, 51.995646041631694, 723.45197804172835, -53.896535947918892,
    ]),
    new Float64Array([
      278795054.94251007, 53321804.309491061, -19497223.32228661, -1612640.3622558261, 166358.67793077527, 22451.054522544146, 3370.3209794908762, -286.78936344782511,
      -1603.5755959192911, 74.286364198227716, 944.47094089811048, -64.012972887108717,
    ])
  ),
  new ChebyshevCoefficients(
    1514764800 as Seconds,
    1546322400 as Seconds,
    new Float64Array([
      -638430630.54329813, -56878620.354061939, 51093374.587761462, 1061352.5674264799, -784818.97390157578, -2716.4756049484013, 22802.453396526973, -583.26864835818606,
      -7258.6984803706409, 401.20932180881499, 4234.3900577892855, -334.82049072186152,
    ]),
    new Float64Array([
      57673683.097219341, -254620762.21518964, -4943502.561752663, 6254663.5708099464, 736.23903846343353, -65525.63205897907, 4762.568009398381, 344.62019065320493,
      -1818.075085418423, 114.8140772908926, 1085.7797452767691, -69.880882544318837,
    ]),
    new Float64Array([
      157252071.18113366, -108458514.89770791, -12740117.079603698, 2732407.8653645325, 160282.89911960164, -30330.820083033046, -2407.3677848219872, 281.44364729324974,
      624.70810586412745, -27.769509541988374, -352.54105918904145, 35.413886181513469,
    ])
  ),
  new ChebyshevCoefficients(
    1546322400 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      -199553910.19237092, 243140057.20589927, 13067170.877739528, -5106495.9943385618, 73793.001074723405, 31959.529567547637, -9578.341085288921, 203.75426937739053,
      3073.2475698590279, -192.39298202991486, -1784.9012769401072, 166.85945543646812,
    ]),
    new Float64Array([
      -662169512.88332558, -66724451.927714564, 40567903.087695949, 322904.09110736847, -395031.03331590793, 20626.33862017691, -3740.4185031344491, -74.423404530684152,
      2217.6101187249023, -152.06973323523999, -1314.2108930855989, 109.02999215920767,
    ]),
    new Float64Array([
      -271547348.98002064, -80992705.154827207, 16466443.908299195, 1193363.7730663035, -201179.64143498588, 3191.4387026178338, 166.67307749266425, -75.518726871162656,
      428.11890300164617, -32.979306116451816, -260.9390176023046, 17.943036395808061,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1609437600 as Seconds,
    new Float64Array([
      651454143.0803231, 144114202.62914053, -32609093.665045649, -2204162.5021212259, 214156.8125696808, 625.9551301578681, 1012.3114143729209, 61.397149268786109,
      -312.74891145626702, 11.960471295317014, 181.17794719735781, -9.7711041182279583,
    ]),
    new Float64Array([
      -370036900.76487738, 193974242.45408908, 18597642.733928226, -3203861.8118914487, -97958.460002885258, 5924.6709305147333, -285.99162510037422, 69.891786164045328,
      -89.084479977687195, 3.3588697950045265, 54.299710953235625, -2.928436893224716,
    ]),
    new Float64Array([
      -307125099.03702092, 62124395.697212309, 15412966.970829332, -1062406.5694229375, -89727.910261074707, 2678.0497175931932, -369.38362863461174, 20.951670902967454,
      33.402546138564745, -1.3145349591970443, -18.165233417352042, 0.97966866493225091,
    ])
  ),
  new ChebyshevCoefficients(
    1609437600 as Seconds,
    1640995200 as Seconds,
    new Float64Array([
      628950596.29496753, -157993200.5560835, -35461101.379440568, 2109218.1061025201, 353683.16106968722, 10749.279978225628, 3541.6864496390026, -361.28697104851403,
      -2097.5468381285668, 98.63138608336449, 1234.6007797002792, -82.414341876904174,
    ]),
    new Float64Array([
      434001939.8537426, 171300746.00982895, -25193189.278971814, -3691006.8854716229, 78979.582069119817, 24394.949643108495, 5754.6927522516498, -164.54453886499007,
      -1818.2091933244219, 87.474966622640693, 1058.5323728726555, -67.462960244715219,
    ]),
    new Float64Array([
      76625672.583191186, 112954129.53930224, -4661692.1230488103, -2170303.9841112318, -34626.318137090901, 9311.6270915145669, 1967.8940167645612, -3.3316348557670912,
      -420.19283450245854, 20.661778405308723, 241.8908314521114, -14.671808785696824,
    ])
  ),
  new ChebyshevCoefficients(
    1640995200 as Seconds,
    1672552800 as Seconds,
    new Float64Array([
      -272535158.98667234, -244169153.13794962, 21854300.461849302, 6178813.7993236203, -142105.11983442109, -68462.916824073589, -8523.3079592699796, 795.59129493832586,
      3610.200510394573, -181.77577799061933, -2080.5082933232188, 184.46484062572321,
    ]),
    new Float64Array([
      530097845.30456251, -137299555.25729543, -40815470.475208163, 2665267.2078103186, 661124.17458047275, -12493.990085707108, -19770.551871313652, 444.6295890788237,
      6237.9313844819862, -353.35777693986893, -3651.9499557216964, 279.62130366961162,
    ]),
    new Float64Array([
      305478495.25910574, -15044892.239999305, -23700459.232687332, -950.74898116985958, 340941.36594508588, 8044.1985901961725, -7623.2281647553045, 48.805241818229355,
      2220.7834283341963, -130.38756928841272, -1306.8268914312125, 94.979941759506858,
    ])
  ),
  new ChebyshevCoefficients(
    1672552800 as Seconds,
    1704110400 as Seconds,
    new Float64Array([
      -606532717.14376664, 97782860.103337616, 45831626.623256899, -3159766.0058409311, -514413.8985730171, 48843.273255197208, 1323.7843219498793, -421.20098001956939,
      530.51055401961003, -63.222239508231482, -359.46099364757538, 2.0212199012438457,
    ]),
    new Float64Array([
      -308465255.60036981, -227370455.98777243, 22384423.813087188, 4867607.5229082499, -471044.29579443188, -33365.938790106775, 19102.134378050763, -439.8612998222311,
      -6321.9634198839467, 400.19649006873368, 3682.3754674911497, -339.85627953807511,
    ]),
    new Float64Array([
      -22022329.580408096, -127144429.90224178, 1226168.056085373, 2939008.4291505567, -117312.57064989855, -25678.520412676036, 8715.0544890349101, -120.80357040464878,
      -3079.4377728064856, 201.0139849881331, 1804.0148320461312, -160.10909844587246,
    ])
  ),
  new ChebyshevCoefficients(
    1704110400 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      180477923.87011102, 248540151.43871573, -9353970.7893180847, -4195328.0963985054, 190362.43599711856, 6781.7783384422464, 149.31803775231043, 103.0637156754732,
      -808.56099391877649, 31.490411673982937, 477.87001183728376, -25.771997419993081,
    ]),
    new Float64Array([
      -672223629.3778342, 57169118.542710319, 36954936.317676395, -1731709.380721424, -223043.49010007779, 19843.092980092762, -4981.1301774084568, -5.0739262561003367,
      1850.1355001588663, -72.725347449382141, -1081.7298530777296, 58.338748353719708,
    ]),
    new Float64Array([
      -353810591.55528468, -23635709.488259677, 19333930.232213978, 37510.538497585061, -143836.37032149086, 7974.8889686038092, -2401.8967070842782, -22.87167520970106,
      1046.2271022021771, -41.067615162332849, -612.76327313333752, 33.046922404070692,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1767225600 as Seconds,
    new Float64Array([
      785462775.49616003, 28644924.24624861, -39674019.829492047, -780141.83410375123, 240096.55103753207, 7212.8774533927435, 1339.8784054418404, -40.574962121248248,
      -291.4547202825546, 11.832227887709935, 170.17095176378885, -12.726411581039429,
    ]),
    new Float64Array([
      -45778171.467491619, 226773469.24506441, 2122448.3290567733, -3672903.0019352473, -54011.690981250009, 4733.4632907519735, -807.68898786306386, 143.03719569146634,
      566.67098220586774, -27.868460559844969, -332.52489253282545, 21.239239823818206,
    ]),
    new Float64Array([
      -181502880.37260962, 101132426.53204542, 9078571.8887289688, -1573676.489430669, -74288.644589607909, 767.17480375766752, -669.83399740358198, 76.045378320415807,
      333.16281045873961, -15.886539925138155, -195.28565880358218, 12.834745949506759,
    ])
  ),
  new ChebyshevCoefficients(
    1767225600 as Seconds,
    1798783200 as Seconds,
    new Float64Array([
      317305498.05464548, -246408165.86246416, -19714574.189888645, 4580830.6914775707, 396976.111046954, -15543.747440123558, -8906.8041885296498, 47.946382208665213,
      2215.2105199933053, -139.61406659881274, -1315.3552463452022, 85.479586337010062,
    ]),
    new Float64Array([
      613881784.31257474, 67280552.21085076, -40082757.805618986, -2425512.1552354703, 313460.23795680999, 38801.037366350494, 8542.4013118098173, -621.7773220171531,
      -3827.7791071991123, 202.82879861394565, 2222.3555005302032, -185.95595104793708,
    ]),
    new Float64Array([
      224957258.67522129, 81899928.995205224, -14893989.070221007, -2077077.6338058338, 67034.598638478667, 21463.396001636112, 5829.6620712578297, -302.41964937237401,
      -2250.5531047460931, 123.79996308498085, 1312.6154972981662, -104.80871184766292,
    ])
  ),
  new ChebyshevCoefficients(
    1798783200 as Seconds,
    1830340800 as Seconds,
    new Float64Array([
      -560205949.30281568, -135721242.44895893, 45941616.953543551, 3414356.7717256569, -715562.34922620002, -36876.660654614367, 21908.782367011903, -321.12293307085832,
      -7048.7882309560973, 471.61801236818235, 4144.588516386847, -355.96282588442165,
    ]),
    new Float64Array([
      244644157.50708547, -235216641.27009597, -20013019.315614797, 5833936.7325748717, 324863.52971751691, -63199.188853627442, -10904.954741382599, 822.61739080746963,
      3651.1264508306981, -191.93775401910145, -2066.2527843018374, 232.18750998973846,
    ]),
    new Float64Array([
      229381143.55995166, -83352901.117045611, -18799760.302031565, 2057419.957755642, 299383.19931212964, -22310.549502085647, -9654.512462493778, 455.21745331684747,
      3176.78382550478, -187.72852224409581, -1829.7249191482861, 183.09616687695186,
    ])
  ),
  new ChebyshevCoefficients(
    1830340800 as Seconds,
    1861898400 as Seconds,
    new Float64Array([
      -371725117.17466652, 211581372.11243117, 25271878.09827847, -5080555.7321225777, -54567.506866453092, 46437.534799776477, -13959.975448526939, 23.554354457060494,
      5201.0084967831772, -204.56430440743765, -3045.3635824183621, 164.23943469524383,
    ]),
    new Float64Array([
      -585279350.1026516, -129941181.0473752, 38112244.373034939, 1741921.7106299475, -481387.48596922209, 11809.722133898735, 2277.8069687133034, -244.23131833920877,
      301.03953914940359, -11.107582014302412, -181.76785297244788, 9.8029182776808739,
    ]),
    new Float64Array([
      -200582777.73222727, -104379576.91465548, 12842755.094032846, 1856518.8097370004, -216094.66569478283, -3881.0088759437822, 3905.8181890138735, -119.84790717760721,
      -911.61091053554162, 36.200210896134379, 531.17390839997677, -28.646727933610478,
    ])
  ),
  new ChebyshevCoefficients(
    1861898400 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      520646383.94319767, 191300137.60522386, -26221550.658003874, -2884859.3010437875, 203238.06688644539, -512.54603621785839, 1781.6941860549152, 63.615772868444523,
      -831.31689021860564, 38.160402726133661, 487.86203416784605, -32.648262837032476,
    ]),
    new Float64Array([
      -508667909.91751134, 157484611.83995962, 25948403.718860663, -2813277.6594973803, -127452.25324424704, 8757.3224127312496, -624.2905566414197, 47.998159305254617,
      -96.414121701320013, 10.928255482514698, 49.131882721185683, 2.9615642110506695,
    ]),
    new Float64Array([
      -346014499.59174615, 35397925.751721814, 17582467.01393953, -740609.65529920661, -101408.85619449317, 4234.6228949964043, -677.09406908651192, 10.252771416306496,
      131.64153384268283, -3.000256362557411, -80.741863245765373, 8.3318342159191765,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    1925013600 as Seconds,
    new Float64Array([
      730172245.81418133, -97659503.466096506, -39357681.247499071, 967707.43050543463, 311035.49007367092, 13600.008600715795, 4326.725818246603, -325.39099380771319,
      -1996.6374077240625, 111.24651975433032, 1166.761007754008, -92.000961808363598,
    ]),
    new Float64Array([
      286482465.47661155, 205006026.1311228, -15934138.975540398, -3868772.2344161309, 10070.875864951809, 15455.439873721698, 2238.2422952309253, 34.435356898605825,
      -296.85909549395245, 27.174948690831659, 186.54315185099841, -3.1022226845224696,
    ]),
    new Float64Array([
      -13365486.029362777, 116631186.08651981, 488430.22314851778, -2022994.5119532307, -58449.012299921116, 4528.0833923593163, 155.81343927731118, 83.106750579178339,
      274.48828453471265, -10.254729121923447, -154.21093150575956, 17.655935812493166,
    ])
  ),
  new ChebyshevCoefficients(
    1925013600 as Seconds,
    1956571200 as Seconds,
    new Float64Array([
      -78027947.140372232, -267802781.16421852, 6710771.4406856876, 6320140.4734074771, 138877.52239230077, -59651.611339575051, -17337.917804573972, 941.92386927207315,
      6351.4900592495997, -380.40935773352783, -3667.8270853986342, 362.02225952645142,
    ]),
    new Float64Array([
      608970215.75907016, -68945220.834567145, -44877001.928651825, 677769.59568423033, 620185.046200488, 14726.591743912299, -10571.688503046831, -51.125073748826978,
      2657.7755282660323, -210.15311966141064, -1608.5610511223474, 104.5470143298308,
    ]),
    new Float64Array([
      303301879.01933146, 21953228.868646819, -22547542.949944671, -966156.05175842938, 264586.80081914662, 19084.700365687906, -1485.8649397671222, -214.79709192961454,
      -28.030676093200842, -22.353049488862354, -18.598832655449709, -23.730095499257246,
    ])
  ),
  new ChebyshevCoefficients(
    1956571200 as Seconds,
    1988128800 as Seconds,
    new Float64Array([
      -650330072.66707933, 20141811.776243791, 51131258.375132531, -1191447.4182934305, -718668.28916805983, 28451.819652708371, 15413.767108933131, -544.27502825458839,
      -4479.8338317990301, 177.69583372076352, 2618.9180534482002, -141.24081088105837,
    ]),
    new Float64Array([
      -126368128.49063875, -252035842.2632488, 9281868.3818969373, 5950718.4455474624, -286249.57851882576, -55867.126338293157, 17064.113006992142, 33.252157971262932,
      -6001.5825530240936, 235.67466569046178, 3514.0431833803655, -189.51578367054464,
    ]),
    new Float64Array([
      72683924.210285187, -123058695.7768099, -6024674.7896659495, 3051149.0932138711, 11305.425562057892, -32157.9787629356, 4888.0192299197115, 127.09754264851411,
      -1909.0647387335698, 74.601665043830877, 1118.6196044653655, -60.328248568375905,
    ])
  ),
  new ChebyshevCoefficients(
    1988128800 as Seconds,
    2019686400 as Seconds,
    new Float64Array([
      -16019243.281484194, 254259014.52536809, 1624251.4144839377, -4752409.6692242753, 152039.26073060531, 17378.296857921283, -4133.7495305200418, 141.08576210935911,
      740.41259221434598, -21.996411647399267, -450.61173612972101, 42.259710352619486,
    ]),
    new Float64Array([
      -691571906.49077106, -4999746.9377357047, 39977639.863419294, -819973.68747553031, -300235.18401823839, 22960.975473113853, -6293.3247156719362, -30.130349765221279,
      2753.7540469189485, -133.9544226070245, -1606.448025526603, 100.97901846170426,
    ]),
    new Float64Array([
      -323163436.25967532, -54095453.273110963, 18540436.261631545, 580493.67478367581, -172480.89210063071, 7305.49271863997, -2151.0715819294255, -42.500404045979181,
      1157.8996324683228, -59.196903030574319, -671.65698672036331, 39.367663848400113,
    ])
  ),
  new ChebyshevCoefficients(
    2019686400 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      738207888.35063994, 90703794.483010247, -36873952.686179653, -1540612.7135263593, 223501.46575802466, 3846.1029972881079, 726.16191278398037, 26.198395516475042,
      -61.827218697468439, 7.422028285264969, 39.664648141463594, 1.3124225010474522,
    ]),
    new Float64Array([
      -219153081.07379702, 216636352.75381812, 10920607.038162043, -3465943.1558871469, -78884.943255392704, 4403.7589726646738, -281.67998818953834, 103.25809764464697,
      124.92777974804243, -7.8133420507113138, -73.466418377558384, 5.1977194269498188,
    ]),
    new Float64Array([
      -253556556.84760013, 83851883.09505561, 12670123.572452875, -1321351.851065441, -82650.047406703234, 1245.775509794553, -332.50333088239034, 45.592975789308547,
      92.857582140962279, -6.3322952340046568, -55.135232029358548, 3.2139560610055922,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2082801600 as Seconds,
    new Float64Array([
      493480748.3767814, -206924219.46404254, -29129665.130773243, 3297841.7479182305, 386424.19542537729, 961.63793183763823, -1008.5980259239674, -298.00274755756061,
      -703.27505344947178, 8.3605193912982934, 359.08971835176152, -71.340882402658465,
    ]),
    new Float64Array([
      542193023.98481429, 126936455.46031828, -33116387.251269002, -3242542.8388774525, 180086.00050295095, 32810.52352605015, 8032.2310091013705, -448.90123470773301,
      -3071.4860749676823, 199.11077780822913, 1795.7379104534784, -161.57127439528705,
    ]),
    new Float64Array([
      155973089.88739687, 102130613.06554699, -9716351.5788364522, -2206821.7786455364, 6441.9711560146261, 15374.604817282656, 3973.9044780207178, -151.09784461371601,
      -1296.7155665819844, 91.647615744173521, 768.71704330146315, -61.213373885179557,
    ])
  ),
  new ChebyshevCoefficients(
    2082801600 as Seconds,
    2114359200 as Seconds,
    new Float64Array([
      -432196197.41318238, -201329436.47999975, 34701154.732490793, 5194850.1126558827, -433198.53133758722, -59970.688351444587, 5918.4910385762651, 389.26675196525952,
      -1414.2069383171697, 53.952858346266048, 825.16833955571053, -44.502134814361732,
    ]),
    new Float64Array([
      414170664.78384531, -191203923.06393865, -32612246.416532811, 4364507.3433442237, 557260.65480354626, -38782.421779062352, -19682.574471948545, 571.29696231484411,
      6499.4795298914114, -256.99268949429194, -3803.8998071988422, 205.1480356534322,
    ]),
    new Float64Array([
      283879534.24376369, -49425647.522190571, -22489804.115235973, 1006142.231291455, 351877.12559248606, -6145.6819413771227, -10518.689314574996, 191.24294317066671,
      3363.5963840107124, -132.59892178475857, -1968.0765549619991, 106.14029268523058,
    ])
  ),
  new ChebyshevCoefficients(
    2114359200 as Seconds,
    2145916800 as Seconds,
    new Float64Array([
      -520649824.6624884, 159076151.02986714, 37377121.570361115, -4354466.6267575622, -291918.39512994088, 52715.818606972694, -8496.2063600242145, -178.80590491890908,
      3815.898835992813, -197.12121767799059, -2207.9338736097015, 127.24033049941063,
    ]),
    new Float64Array([
      -454125492.0942927, -187714309.2028738, 31457829.484948788, 3477789.2808768172, -516269.55967481545, -10949.475529022826, 12559.259441967992, -324.2722155685226,
      -3594.0347397425521, 161.18704530702283, 2115.1403547716018, -147.06663953457027,
    ]),
    new Float64Array([
      -108740526.07066606, -121166558.35415652, 7265724.9879474714, 2531511.0163052678, -184612.40574872543, -15914.722036507725, 7648.9919887329143, -116.41518044074377,
      -2468.1985677396256, 115.94574041068553, 1444.9252724995215, -95.153842697044212,
    ])
  ),
  new ChebyshevCoefficients(
    2145916800 as Seconds,
    2177474400 as Seconds,
    new Float64Array([
      349632180.63276583, 228962260.57867375, -18162809.375566855, -3634522.2413672796, 204303.39679524204, 2256.4588267227014, 1586.6648012707631, 60.759427903592588,
      -1106.4653426279624, 62.746967394649978, 651.29290733138714, -49.567865818738937,
    ]),
    new Float64Array([
      -611748613.32634151, 109231729.252379, 32593018.321055736, -2346980.0238687852, -175524.09954661728, 14906.332980149984, -2665.5075459818045, 34.044357424974443,
      773.37787290016809, -43.310031785567602, -449.69340829650559, 34.8337520301342,
    ]),
    new Float64Array([
      -360492328.44991136, 5038078.7419474032, 19112676.458934285, -369725.74327047268, -124471.27764002483, 6583.37215462923, -1612.813517360886, 4.7503061721722286,
      602.98348599672318, -33.8922119329373, -352.22458142340184, 27.143610213200251,
    ])
  ),
  new ChebyshevCoefficients(
    2177474400 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      781837887.49281681, -31663175.590993825, -40622894.063664772, 34949.964422110716, 272307.32379537023, 10082.31307965517, 2567.1416803518932, -154.38619535168013,
      -946.84760850469274, 73.167988747358322, 569.60191861192379, -39.188205629587173,
    ]),
    new Float64Array([
      119823124.12713557, 223742543.2228637, -6522713.9455498625, -3825941.3719424815, -22969.974294252195, 8679.0037637283403, -76.826410747567806, 146.30517882208028,
      468.64840434491634, -14.880064322551091, -252.98367191950479, 39.136289770404495,
    ]),
    new Float64Array([
      -102501007.59957173, 112268067.32972459, 5186182.6800155835, -1816717.420117426, -66135.381388480469, 2052.7062551071244, -592.72087505161767, 101.88109771708648,
      428.19900520245233, -22.748031495014825, -243.5697166810433, 27.283337415258089,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2240589600 as Seconds,
    new Float64Array([
      132552887.8395825, -266018222.86993107, -8122057.7152979253, 5557182.5783977527, 313253.98806320428, -35555.203241149582, -14715.370912762482, 340.95731283426284,
      4747.799624586105, -187.09992459019026, -2776.9320205926897, 149.76265848278999,
    ]),
    new Float64Array([
      640532406.88269174, 4702437.8557096459, -43830089.683326893, -1130589.3805475673, 458417.23670750257, 31999.466031920911, 1964.9637163162231, -427.09095341165857,
      -1726.9782652507226, 69.710037042697266, 1015.7846854209899, -54.782261123259865,
    ]),
    new Float64Array([
      275978548.56881154, 56389627.300081395, -19076965.392894667, -1666409.9482880491, 153145.89437652653, 22374.3424809811, 3900.0771433159707, -270.88120483656724,
      -1773.0455483205617, 70.652831512937937, 1039.7102104462683, -56.072588049123681,
    ])
  ),
  new ChebyshevCoefficients(
    2240589600 as Seconds,
    2272147200 as Seconds,
    new Float64Array([
      -632472432.21414244, -65480219.821762227, 50823034.139647894, 1347264.7979374221, -786407.53957694967, -7569.0550264567137, 23398.056352488198, -452.97011886636415,
      -7491.1462493817007, 358.86823487281799, 4375.1966684679192, -281.49525026679038,
    ]),
    new Float64Array([
      79284457.538513914, -253635353.96040416, -6639096.0347662689, 6249594.7626906652, 43158.364327800271, -66112.82065466643, 2397.8057278732458, 431.98461329738296,
      -1030.266476825873, 64.459722089767453, 575.12636522650723, -20.858626059691112,
    ]),
    new Float64Array([
      166280925.02570879, -106639264.42999518, -13491864.536615169, 2681142.6562169301, 180628.40437486966, -29715.283135052523, -3640.18151850303, 296.63529837727549,
      1042.154866022865, -42.800313645601271, -621.22483669221401, 47.586168669660886,
    ])
  ),
  new ChebyshevCoefficients(
    2272147200 as Seconds,
    2303704800 as Seconds,
    new Float64Array([
      -217309981.47685263, 241156521.73044467, 14312024.535041185, -5154593.9062288962, 65794.239940345287, 34228.339974582195, -10681.593867776792, 173.92593552867572,
      3532.3645083606243, -195.46226847767829, -2060.0673471669356, 162.4547962586085,
    ]),
    new Float64Array([
      -654783127.81682956, -73297982.874617398, 40580906.06227494, 459275.88440210122, -409544.29455601674, 20269.783562446635, -3119.7778993229072, -117.75806760191917,
      2047.1407946507136, -118.73532559971015, -1208.4679732332627, 89.311910312374437,
    ]),
    new Float64Array([
      -265533639.70292482, -83801884.646721199, 16280139.54173205, 1267837.3494381681, -207025.31966685306, 2600.0966691650451, 688.03886483137808, -90.575093069920939,
      253.59429466451206, -16.596558374663193, -154.77158693174522, 9.39243427477777,
    ])
  ),
  new ChebyshevCoefficients(
    2303704800 as Seconds,
    2335262400 as Seconds,
    new Float64Array([
      640799246.07731867, 148976244.78467709, -32153795.81075168, -2266157.4473986267, 214509.12755192319, 358.05552165607611, 1167.8473135530949, 52.531982954343157,
      -389.0746832261483, 29.430258079369864, 232.74493116239705, -16.187408458193143,
    ]),
    new Float64Array([
      -382640410.69455975, 191117330.79203245, 19317654.78790462, -3185262.0126318554, -99467.380016652736, 6252.9018336951731, -272.10882755120593, 59.379169076681137,
      -122.65643253525099, 3.9867564042409263, 68.26658860445022, -10.078125343720117,
    ]),
    new Float64Array([
      -311591646.18967634, 60070574.653206579, 15690622.313582884, -1045269.0793575763, -90704.988658687478, 2886.8249664972227, -385.85520044366518, 18.10019541780154,
      29.282372748851774, -4.5833045681317648, -19.76235851943493, -1.0042409022649128,
    ])
  ),
  new ChebyshevCoefficients(
    2335262400 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      639960878.39867306, -152745556.23898157, -35886642.793916449, 2007620.0895624517, 348469.74865644373, 10899.25355899334, 3640.0153517742951, -331.08197172085443,
      -2094.5850859900315, 83.68495261271795, 1229.7130972166856, -66.319629575808847,
    ]),
    new Float64Array([
      422506794.35410345, 174803040.78385741, -24372766.88153505, -3703863.7567116856, 73419.175778084871, 23303.731981102625, 5310.1956515469901, -127.18402870918314,
      -1631.2355315330128, 64.014912284165618, 951.98520176665238, -51.341492538154121,
    ]),
    new Float64Array([
      69516516.351998717, 113823414.13229369, -4221078.6512191389, -2161544.3192411936, -36154.74929280331, 8805.3980874692406, 1751.8437328219413, 7.7099088490009304,
      -337.31692082484562, 12.932213242352008, 195.34378062337638, -10.535081019997596,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2398377600 as Seconds,
    new Float64Array([
      -255332052.2636174, -247259717.13452926, 20377729.41812028, 6201991.4745001812, -111559.07111240327, -67467.355366604024, -9688.5852206692107, 746.39850394030407,
      3944.105822636187, -179.87418756236633, -2325.8466224119065, 160.3382269412279,
    ]),
    new Float64Array([
      540497780.45474958, -130928487.56414956, -41284268.773259364, 2463580.4442969998, 656631.59411281545, -9357.0257088561848, -18711.022317641975, 311.05678885181743,
      5846.1296196997164, -284.62720246513686, -3404.9517977396645, 214.18638538519542,
    ]),
    new Float64Array([
      307727568.06179255, -11578290.489952099, -23685408.811791107, -97726.0015163223, 333549.40379266441, 9311.2074702580776, -6906.0321772098541, -4.1356674661238984,
      1973.5139237115779, -98.569639925161994, -1143.589178827405, 69.069825632373494,
    ])
  ),
  new ChebyshevCoefficients(
    2398377600 as Seconds,
    2429935200 as Seconds,
    new Float64Array([
      -614379888.50473487, 90275444.796526775, 46551202.019233637, -2965013.5320138456, -538927.73343233066, 46831.731792692342, 2955.7933810532095, -442.0425158361594,
      -30.056059090296426, -10.05068881313006, -6.3177727639675139, -12.496524155139923,
    ]),
    new Float64Array([
      -290326693.37778509, -230570165.40921235, 21124965.639404364, 4997697.8077012841, -452970.24100939033, -36056.343368251619, 18955.649469985066, -330.43663696249325,
      -6301.8197489395734, 350.72364576210578, 3681.1288859372339, -288.25880805204309,
    ]),
    new Float64Array([
      -12233437.133614037, -127485145.2496326, 511099.95855365595, 2968635.9133268404, -104360.70377710462, -26599.234824477633, 8336.2258317629494, -65.3625937645634,
      -2963.2204759851097, 167.3270113910238, 1735.8132996290922, -133.25538744380077,
    ])
  ),
  new ChebyshevCoefficients(
    2429935200 as Seconds,
    2461492800 as Seconds,
    new Float64Array([
      160235879.5050025, 250087845.80428112, -8301447.3228891212, -4274173.0140998028, 187718.42218898633, 8015.7707476586102, -320.07595281302929, 88.34187689721584,
      -633.14998807410393, 45.903875904281932, 382.40041494766871, -29.217562916874886,
    ]),
    new Float64Array([
      -675304745.71930254, 51224886.661229715, 37399145.612916313, -1649180.391698265, -232226.15067248742, 20190.517929687103, -5148.9974478880567, 57.092790273825329,
      1957.3112684686978, -126.08936685125033, -1143.0501029253005, 103.0558031519254,
    ]),
    new Float64Array([
      -352190089.6937086, -26709723.080537915, 19386813.016141415, 90482.367601083213, -148013.26097066503, 7918.0299283822378, -2394.9649266843994, 9.9660006955265992,
      1065.0614246393243, -69.58503371874491, -624.47309836198883, 55.302215176820752,
    ])
  ),
  new ChebyshevCoefficients(
    2461492800 as Seconds,
    2493050400 as Seconds,
    new Float64Array([
      782125926.54265678, 34752691.758077241, -39573601.150013007, -854346.33824208775, 240130.24840914211, 6853.3930447320145, 1266.3538870453835, -29.815754125515621,
      -267.9695131023725, 10.307802855968475, 153.68760498364767, -8.2885227839152016,
    ]),
    new Float64Array([
      -61937995.79942704, 226493704.69273314, 2961788.8846891881, -3668818.8761749766, -55995.424617907403, 4793.4652556965748, -767.22984946568806, 134.60144140323004,
      527.6336628844341, -21.320301393667858, -310.36332235833009, 16.738197468717892,
    ]),
    new Float64Array([
      -188652953.48729789, 100091077.01696847, 9463014.1651292201, -1561862.3243184695, -75263.092684294781, 867.09785082538917, -650.64057850937047, 70.427823840578398,
      316.14868855774404, -12.658098339041073, -185.13975898424783, 9.9847682336966201,
    ])
  ),
  new ChebyshevCoefficients(
    2493050400 as Seconds,
    2493072000 as Seconds,
    new Float64Array([
      771097304.10300827, -87125.399592034024, -18.48537512421608, 0.00044607321421305339, 3.9736429850260416e-9, -1.9868214925130209e-7, -3.9736429850260414e-8,
      6.4174334208170567e-7, 2.9802322387695313e-8, 7.6691309611002607e-7, -2.9802322387695313e-8, 4.3908754984537758e-7,
    ]),
    new Float64Array([
      389812283.90914547, 139963.63092299501, -9.3388557434082031, -0.0012516200542449952, -2.0861625671386717e-8, 3.4173329671223959e-7, -1.2914339701334636e-8,
      -6.3578287760416663e-7, 8.9406967163085934e-9, -0.0000012139479319254558, -2.9802322387695314e-9, -7.9969565073649085e-7,
    ]),
    new Float64Array([
      27349899.804098804, 83976.95412769969, -0.65237562215576572, -0.00068308077752590182, -1.5335778395334878e-8, 1.9719203313191731e-7, -1.5522042910257976e-9,
      -4.3362379074096677e-7, 1.3659397761027017e-9, -7.2239587704340613e-7, 1.241763432820638e-10, -4.7025581200917562e-7,
    ])
  ),
];
